import React from 'react'

const ButtonWhiteReturn = ({ icon, title, onClick, iconOrText, alingment = "justify-content-between" }) => {
    return (
        <div className={`d-flex align-items-center white-color ${alingment}`}>
            <i
                type='button'
                onClick={onClick}
                className="fa-solid fa-arrow-left d-block fs-3"
            >
            </i>
            <div className='d-flex flex-column'>
                {icon ?
                    <div className='d-flex justify-content-center pb-1'>
                        <img src={icon} alt="logo" />
                    </div>
                    : null
                }
                <h5 className='m-0 text-center'>
                    {title}
                </h5>
            </div>

            {iconOrText ? <div>{iconOrText}</div> : <div></div>}
        </div>

    )
}

export default ButtonWhiteReturn